import React from 'react'
import { getRoundValue } from "@core/old_helpers"
import './ProfileItem.scss'
import cn from "classnames";
import { highlightMatches } from "@core/helpers";

const FoodProfileItem = ({
    title = '',
    value = '',
    isTag = false,
    searchQuery = '',
}) => {
    return (
        <div className='profile-item'>
            <span
                className={cn(
                    'profile-item__title', 'profile-item__val',
                    !isTag && 'is-light',
                    isTag && 'tag-label',
                )}
                dangerouslySetInnerHTML={{ __html: highlightMatches(title, searchQuery) }}
            />
            <span className='profile-item__value profile-item__val'>{getRoundValue(value)}</span>
        </div>
    )
};

export default FoodProfileItem;